// import apm from "./monitor-apm";
import beidou from "./monitor-beidou"
import project from "../../../package.json"
import { getUser } from "../../utils"
import { logger } from "../../utils/libs/logger.lib"
import apm from "./monitor-apm"
declare const window: any
const log = logger("[monitor.js]")
const { name, version, description } = project

// 员工职位 Staff position
const staffPosition: any = {
  10: "客户经理",
  20: "团队主管",
  30: "小区经理",
  40: "大区经理",
  50: "总经理",
}
// 北斗埋点

export const addBeidouEvent = (
  ops: {
    pageAlias?: any
    searchKeys?: any
    hzCustomerId?: any
    clickKey?: string
    pagePostion?: string
    clickAlias?: string
    platformType?: string
    elementType?: string
    productId?: string | number | Array<string | number>
    batchId?: string | number
    elementContent?: string | Array<string>
    loginId?: string | number
    /** @description 计划ID */
    planId?: string | number
    urlAlias?: string
    title?: string
    depth?: number
    businessScene?: string
    contentId?: string | number | Array<string | number>
    matchContent?: string
    sendType?: string | number
    /** @description 是否是分享落地页 */
    isShare?: boolean
    /** 浏览时间 */
    stayTime?: number
    [keys: string]: any
  },
  /** @description 事件英文变量名 @type string */
  event?: string,
) => {
  const user: any = getUser()
  const { employeeWorkCode, employeeJobCode } = user
  const {
    hzCustomerId,
    pagePostion,
    clickAlias,
    clickKey,
    pageAlias,
    searchKeys,
    platformType = "H5",
    elementType,
    productId,
    batchId,
    elementContent,
    loginId,
    planId,
    urlAlias,
    title,
    depth,
    contentId,
    businessScene,
    matchContent,
    sendType,
    isShare,
    stayTime,
    ...rest
  } = ops || {}

  const role_name = staffPosition[employeeJobCode] || "其他"

  const page_url = window.location.href
  let page_title = document.title || title

  try {
    page_title = (document.title || "").split("-")[0]?.trim()
  } catch (error) {}

  try {
    let param: any = {
      role_name,
      page_url,
      page_alias: pageAlias, //页面别名
      search_keys: searchKeys,
      click_key: clickKey, //事件KEY，不传
      page_title,
      platform_type: platformType,
      click_alias: clickAlias, //事件名称，别名
      page_postion: pagePostion, //页面位置
      hz_customer_id: hzCustomerId, //客户ID
      employee_work_code: employeeWorkCode || undefined, //顾问ID
      $element_type: elementType, //元素类型
      product_id: productId, //元素对应数据ID
      batch_id: batchId, //关联的批量操作的ID
      $element_content: elementContent, //关键词名称
      login_id: loginId, //客户ID
      plan_id: planId,
      $url_alias: urlAlias, // 页面完整url
      $title: title || page_title,
      depth,
      business_scene: businessScene,
      content_id: contentId,
      match_content: matchContent,
      send_type: sendType,
      is_share: isShare,
      stayTime,
      ...rest,
    }
    const options: any = {}
    Object.keys(param).forEach((key) => {
      if (param[key] !== undefined) {
        options[key] = param[key]
      }
    })
    // window.Beidou?.track("wp_emptools_click", options);
    window.BeidouDatadynamicInject?.beidou?.track(
      event || "wp_emptools_click",
      options,
    )
  } catch (error) {}
}

export default function foo() {
  if (localStorage.getItem("pure")) {
    return
  }
  log.info(`server: ${name},version: ${version},desc: ${description}.`)
  apm({ version: version, serviceName: name })
  beidou()
}
